import { Translation } from '@ps/web-shared-components';
import type { FC } from 'react';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import { TXTWCL_Returns, TXTWCL_n_a } from './ReturnsRow.messages.json';
import styles from './ReturnsRow.scss';

interface Props {
  totalPotentialWinToDisplay: number | undefined;
}

export const ReturnsRow: FC<Props> = ({ totalPotentialWinToDisplay }) => (
  <p className={styles.container}>
    <span>
      <Translation {...TXTWCL_Returns} />:{' '}
    </span>
    <span className={styles.value}>
      {totalPotentialWinToDisplay ? (
        <CurrencyAmount value={totalPotentialWinToDisplay} />
      ) : (
        <Translation {...TXTWCL_n_a} />
      )}
    </span>
  </p>
);
